import React, { useState, useEffect } from "react";
import "../Testing.css";
import { useTypedSelector } from "../../../../redux/reducers/RootReducer";
import {
  getSuiteMode,
  getImagerTestingState,
} from "../../../../redux/reducers/ModuleStateReducer";
import ToolsContentButton from "../../ToolsCommon/ToolsContentButton";
import { ESuiteMode, ETestingState } from "../../../../Model/ModuleState";
import TestingApi from "../../../../api/TestingApi";
import { ETestingType } from "../../../../Model/TestingParameter";

type Props = {
  imagerIdentifier: string;
};

export default function AutoExposureTest({ imagerIdentifier }: Props) {
  const imagerTesting = useTypedSelector((state) =>
    getImagerTestingState(state, imagerIdentifier)
  );
  const suiteMode = useTypedSelector((state) => getSuiteMode(state));
  const [status, setStatus] = useState("status....");
  const isDisabled = suiteMode !== ESuiteMode.Normal;
  const isRunningAutoExposureTest =
    suiteMode === ESuiteMode.Testing &&
    imagerTesting.autoExposure?.state === ETestingState.Started;

  const runExposureTest = () => {
    TestingApi.doTesting({
      moduleIdentifier: imagerIdentifier,
      type: ETestingType.AutoExposure,
    });
  };

  const stopExposureTest = () => {
    TestingApi.stopTesting();
  };

  useEffect(() => {
    if (imagerTesting.autoExposure?.state === ETestingState.Started) {
      const counter = imagerTesting.autoExposure.counter ?? 0;
      setStatus("Count :" + counter.toString());
    }
  }, [imagerTesting.autoExposure?.counter]);

  return (
    <div className={"testing-content"}>
      <div className={"testing-card no-border"} style={{marginTop: 0}}>
        <div>Auto Exposure Test</div>
        <div className={"testing-button-group"}>
          <ToolsContentButton
            text="Stop"
            onClick={stopExposureTest}
            disabled={!isRunningAutoExposureTest}
            variant="primary"
            colorVariant="black"
          />
          <ToolsContentButton
            text="run"
            onClick={runExposureTest}
            disabled={isDisabled}
            variant="primary"
            colorVariant="default"
          />
        </div>
      </div>
      <div
        className={"testing-status-box"}
        style={{
          opacity: isDisabled ? 0.5 : 1,
        }}
      >
        <p>{status}</p>
      </div>
    </div>
  );
}
